module.exports = __webpack_public_path__ + "static/media/iiitdmj.5365fd50.png";